import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { MAP_BREAKPOINT } from './variables';

const ProductMark = withStyles((theme) => ({
  root: {
    position: 'relative',
  },
  frame: {
    backgroundColor: theme.props.palette.secondary.main,
    borderRadius: 30,
    height: theme.spacing(7),
    [theme.breakpoints.up(MAP_BREAKPOINT)]: {
      borderRadius: '50%',
      width: 140,
      height: 140,
    },
  },
  wrapper: {
    display: 'flex',
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.common.white}`,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    textAlign: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: 'auto',
    width: `calc(100% - ${theme.spacing(1)}px)`,
    height: theme.spacing(6),
    [theme.breakpoints.up(MAP_BREAKPOINT)]: {
      height: `calc(100% - ${theme.spacing(1)}px)`,
      '& span': {
        display: 'block',
        fontSize: theme.typography.pxToRem(14),
      },
    },
    '& > *': {
      margin: 'auto',
    },
  },
}))(({ classes }) => (
  <div className={clsx(classes.root, classes.frame)}>
    <div className={clsx(classes.frame, classes.wrapper)}>
      <div>
        <span>連携する産地</span>
        <span>まだまだ拡大中！</span>
      </div>
    </div>
  </div>
));

export default ProductMark;
